module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAsElEQVQ4je3UMWoCQRQG4M9hm4AI7g0sgrfQRnKLdN7ARrCX1HaLpbcQG8FDLFh5gRXEXosZIekysuX+8Mr38WaKv1dVFXziBzMM5OWGA5Y4B4xxwhEj9DJnlHZPGBdYp9lkXvZKk3Y/sA7iM3dvYr+zxVcQ/6xpAWzQDy1Af9KBHdiB/wVvKFuwStyDWI7fLYBz7AusxIJ8iDV2zYSG6aAFpgE1JpjikuCcuaTdCeon7lQqlk36XBsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/courier/meixuanzhong.png
// module id = kNLt
// module chunks = 3